import React, { useEffect } from 'react';
import RouteConstants from '../../constants/routeConstants';
import { Box, Button, Card, CircularProgress, TextField, Divider } from '@mui/material';
import { makeStyles } from '@mui/styles';
import DataList from '../Notification/dataList/dataList';
import { FULL_PERMISSION } from '../../constants/Constant';
import Title from '../../sharedcomponents/title/title';
import { createTheme } from '@mui/system';
import APIURLConstants from "../../config/config";
import ApiHelper from '../../utility/ApiHelper';
import Helper from '../../utility/helper';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import LoadingButton from '@mui/lab/LoadingButton';

const theme = createTheme();

const useStyles = makeStyles(() => ({
    subPaperContent: {
        boxShadow:
            'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
        borderRadius: theme.spacing(1),
        padding: theme.spacing(3),
        height: '100%',
        width: '100%',
        display: 'flex',
    },
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
    },
}));

const ChargeCard = () => {
    const classes = useStyles();
    const [loading, setLoading] = React.useState(false);
    const [token, setToken] = React.useState('')
    const [tokenErr, setTokenErr] = React.useState('')
    const [amount, setAmount] = React.useState('')
    const [amountErr, setAmountErr] = React.useState('')

    const [chargeCardData, setChargeCardData] = React.useState([])
    const [showSearchRec, setShowSearchRec] = React.useState(false);
    const [btnLoading, setBtnLoading] = React.useState(false);
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    // const userInfo = Helper.getStorage('userInfo');

    // console.log("asdasd",userInfo,Helper.isPaymentUser(userInfo.userID));
    const getPaymentData = () => {
        let paymentData = [];
        setLoading(true);
        ApiHelper.get(APIURLConstants.GET_CHARGE_PAYMENT_DETAILS())
            .then(res => {
                setLoading(false)
                let data = res.data;
                if (data.length > 0) {
                    data.map((item) => {
                        paymentData.push({
                            actualData: item,
                            row: [
                                // {
                                //     label: 'checkbox',
                                //     key: 'paymentID',
                                //     paymentID: item.paymentID,
                                //     width: '0.03',
                                // },
                                {
                                    label: 'Participant',
                                    key: 'participant',
                                    participant: item.participant,
                                    width: '0.15',
                                    alignCenter: true,
                                    inColumn: true,
                                },
                                {
                                    label: 'Connection',
                                    key: 'connection',
                                    connection: ' ' + item.connectionName,
                                    width: '0.15',
                                    alignCenter: true,
                                    inColumn: true,
                                },
                                {
                                    label: 'Credit Card',
                                    key: 'creditCard',
                                    creditCard: item.cardName,
                                    width: '0.13',
                                    alignCenter: true,
                                    inColumn: true,

                                },
                                {
                                    label: 'Amount',
                                    key: 'amount',
                                    amount: '$' + item.amount,
                                    width: '0.10',
                                    alignCenter: true,
                                    inColumn: true,

                                },
                                {
                                    label: 'Date Time',
                                    key: 'dateTime',
                                    dateTime: Helper.FormatDate(
                                        item.createdDate
                                    ) + ' ' +
                                        Helper.FormatTime(
                                            item.createdDate
                                        ),
                                    width: '0.20',
                                    alignCenter: true,
                                    inColumn: true,

                                },
                                {
                                    label: 'Status',
                                    key: 'status',
                                    status: item.status,
                                    width: '0.07',
                                    alignCenter: true,
                                    inColumn: true,

                                },
                                {
                                    label: 'Error',
                                    key: 'error',
                                    error: item.error,
                                    width: '0.20',
                                    alignCenter: true,
                                    inColumn: true,
                                },
                                // {
                                //     label: 'Action',
                                //     key: 'edit',
                                //     edit: 'Edit',
                                //     width: '0.07',
                                // },                                
                            ],
                            expanded: false,
                            selected: false,
                        });
                    });
                }
                setChargeCardData(paymentData);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
            });
    }
    useEffect(() => {
        getPaymentData()

    }, [])
    const onTokenChange = () => {
        // console.log("token", token);
        if (token === '') {
            setTokenErr('Please Enter Token')
            return { flag: 'false' };
        } else {
            setTokenErr('');
        }
    }
    const onAmountChange = () => {
        if (amount === '') {
            setAmountErr('Please Enter Amount')
            return { flag: 'false' };
        } else {
            setAmountErr('');
        }
    }
    const handleSubmit = () => {
        const vToken = onTokenChange();
        const vAmount = onAmountChange();
        // console.log("submitted");
        if (vToken?.flag === 'false' || vAmount?.flag === 'false') {
            return;
        }
        const userInfo = Helper.getStorage('userInfo');
        const postPaymentData = {
            token: token,
            shopReference: '',
            amount: amount,
            createdBy: userInfo.userID
        }
        setBtnLoading(true)
        ApiHelper.post(APIURLConstants.POST_CHARGE_DETAILS, postPaymentData)
            .then(async (res) => {
                console.log("res", res);
                if (res.data) {
                    setBtnLoading(false)
                    setToken('')
                    setTokenErr('')
                    setAmount('')
                    setAmountErr('')
                    setSnackBarProps({
                        snackBarProps,
                        openSnack: true,
                        variant: res.data.resultCode && res.data.resultCode === 'Authorised' ? 'success' : 'error',
                        message: res.data.resultCode && res.data.resultCode === 'Authorised' ? 'Card Charged Successfully' : res.data.errorCode !=='' ? res.data.message : 'Please enter the correct information.', //Error in Adyen transaction. Please enter the correct information.
                    });
                    getPaymentData()
                }
            })
            .catch((err) => {
                setBtnLoading(false)
                setSnackBarProps({
                    snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: 'err',
                });
                getPaymentData()
                console.log(err);
            });
    }
    const preventMinus = (e) => {
        if (e.code === 'Minus') {
            e.preventDefault();
        }
    };
    return (
        <>
            <Box sx={{ width: '100%' }}>
                {loading ? (
                    <Box
                        sx={
                            loading
                                ? { paddingTop: '20%', paddingBottom: '20%' }
                                : ''
                        }
                        className={classes.loader}>
                        <CircularProgress />
                    </Box>
                ) :
                    <Box
                        sx={{
                            // p: 2,
                            width: '100%',
                        }}>
                        <Box className='contentBox'>
                            <Title title={"Charge Card"} />

                            <Box>
                                <Card classes={{ root: classes.subPaperContent }} >
                                    {/* Charge Card */}
                                    <Box display="flex" flexDirection='row'>
                                        <Box sx={{ width: "40%" }}>
                                            <TextField
                                                fullWidth
                                                required
                                                sx={{
                                                    width: {
                                                        xs: '100%',
                                                        md: '100%',
                                                    },
                                                    paddingRight: 2
                                                }}
                                                size="small"
                                                id="outlined-required"
                                                // onKeyDown={(e) => {setToken(e.target.value); onTokenChange();}}
                                                // onPaste={(e) => {setToken(e.clipboardData.getData('Text')); onTokenChange();}}
                                                inputProps={{ maxLength: 50 }}
                                                value={token}
                                                onChange={(e) => {
                                                    setToken(e.target.value)
                                                    onTokenChange();
                                                    setTokenErr('')
                                                }}
                                                label="Token"
                                                error={
                                                    tokenErr.length > 0
                                                        ? true
                                                        : false
                                                }
                                                helperText={
                                                    tokenErr.length > 0
                                                        ? tokenErr
                                                        : ''
                                                }
                                            />
                                        </Box>
                                        <Box sx={{ width: "40%" }}>
                                            <TextField
                                                type="number"
                                                size="small"
                                                fullWidth
                                                id="outlined-basic"
                                                variant="outlined"
                                                onKeyPress={preventMinus}
                                                value={amount}
                                                inputProps={{
                                                    min: 0,
                                                    step: "1"
                                                }}
                                                sx={{
                                                    width: {
                                                        xs: '100%',
                                                        md: '100%',
                                                    },
                                                    pr: 2
                                                }}
                                                onChange={(e) => { setAmount(e.target.value); onAmountChange(); }}
                                                error={
                                                    amountErr.length > 0
                                                        ? true
                                                        : false
                                                }
                                                helperText={
                                                    amountErr.length > 0
                                                        ? amountErr
                                                        : ''
                                                }
                                                label="Amount"

                                            />
                                        </Box>
                                        <Box sx={{ width: '20%' }}>
                                            {btnLoading ? (<LoadingButton
                                                loading
                                                variant="contained"
                                                size="small"
                                                spacing={2}>
                                                Charge
                                            </LoadingButton>) :
                                                (<Button
                                                    variant="contained"
                                                    size="small"
                                                    spacing={2}
                                                    onClick={handleSubmit}
                                                >
                                                    Charge
                                                </Button>)}


                                        </Box>
                                    </Box>
                                </Card>

                            </Box>
                            <Divider sx={{ mt: 1, mb: 1 }}></Divider>
                            <Box className='contentBox'>
                                <DataList
                                    data={chargeCardData}
                                    // onCheckSelect={onCheckSelect}
                                    // editRow={editTicket}
                                    // handleClick={redirectToCreate}
                                    title={''}
                                    // buttonTitle={'Add'}
                                    hideAdd={true}
                                    hideDelete={true}
                                    // deleteRows={deleteSettingsList}
                                    showSearch={true}
                                    searchLabel={'Search'}
                                    showSearchRec={showSearchRec}
                                    setShowSearchRec={setShowSearchRec}
                                    modPermission={FULL_PERMISSION}
                                // toggleChange={toggleChange}
                                />
                            </Box>
                        </Box>
                    </Box>}
                {snackBarProps.openSnack && (
                    <CustomizedSnackbars
                        {...snackBarProps}
                        onClose={() =>
                            setSnackBarProps({ ...snackBarProps, openSnack: false })
                        }></CustomizedSnackbars>
                )}
            </Box>
        </>
    )

}

export default {
    routeProps: {
        path: RouteConstants.CHARGE_CARD,
        component: ChargeCard,
    },
    name: 'ChargeCard',
};
